import { gql } from "@apollo/client";

import complianceProgramReportAssessmentFragment from "@apps/reporting/graphql/compliance-program-report-assessment-fragment";

export default gql`
  ${complianceProgramReportAssessmentFragment}
  mutation unsubmitAssessment($assessmentIds: [Int!]!) {
    reopenAssessment(assessmentIds: $assessmentIds) {
      assessments {
        id
        state
        assessmentDeliveryState
        assessmentDelivery {
          id
          state
        }
      }
      reportRows {
        edges {
          node {
            id
            assessment {
              ...ComplianceProgramReportAssessment
            }
          }
        }
      }
    }
  }
`;
